import { render, staticRenderFns } from "./Remission.vue?vue&type=template&id=beabd64e&scoped=true&"
import script from "./Remission.vue?vue&type=script&lang=js&"
export * from "./Remission.vue?vue&type=script&lang=js&"
import style0 from "./Remission.vue?vue&type=style&index=0&id=beabd64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beabd64e",
  null
  
)

export default component.exports